module.exports = __webpack_public_path__ + "static/media/qrCodeTutor.d39b7453.svg";